/**
 * STUDIO BUILDIN — Theme Scripts
 * Bestand: assets/sb-scripts.js
 * Versie:  1.0.0
 *
 * Voeg toe aan layout/theme.liquid (voor </body>):
 * <script src="{{ 'sb-scripts.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ── 1. Scroll Reveal ── */
  function initReveal() {
    const els = document.querySelectorAll('.sb-reveal');
    if (!els.length) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('sb-visible'); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
  }

  /* ── 2. Counter Animation ── */
  function animateCounter(el, target, suffix) {
    const dur = 1800;
    const startTime = performance.now();
    function step(now) {
      const progress = Math.min((now - startTime) / dur, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(ease * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    const els = document.querySelectorAll('.sb-stats__num[data-target]');
    if (!els.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const target = parseInt(e.target.dataset.target, 10);
            const suffix = e.target.dataset.suffix || '';
            if (!isNaN(target)) animateCounter(e.target, target, suffix);
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach((el) => observer.observe(el));
  }

  /* ── 3. Custom Cursor (desktop only) ── */
  function initCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const dot  = document.getElementById('sb-cursor');
    const ring = document.getElementById('sb-cursor-ring');
    if (!dot || !ring) return;

    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });

    function tick() {
      rx += (mx - rx) * 0.15;
      ry += (my - ry) * 0.15;
      dot.style.left  = mx + 'px';
      dot.style.top   = my + 'px';
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(tick);
    }
    tick();

    document.querySelectorAll('a, button, .sb-service, .sb-portfolio-card').forEach((el) => {
      el.addEventListener('mouseenter', () => {
        dot.style.width  = '18px'; dot.style.height  = '18px';
        ring.style.width = '56px'; ring.style.height = '56px';
      });
      el.addEventListener('mouseleave', () => {
        dot.style.width  = '10px'; dot.style.height  = '10px';
        ring.style.width = '36px'; ring.style.height = '36px';
      });
    });
  }

  /* ── 4. Nav Scroll Style ── */
  function initNav() {
    const nav = document.querySelector('.sb-nav');
    if (!nav) return;
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 60
        ? 'rgba(8,8,8,0.98)'
        : 'rgba(8,8,8,0.92)';
    }, { passive: true });
  }

  /* ── 5. Contact Form (Shopify AJAX) ── */
  function initContactForm() {
    const form = document.querySelector('.sb-contact-form');
    if (!form) return;
    const btn     = form.querySelector('[type="submit"]');
    const msgEl   = form.querySelector('.sb-form__message');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.textContent = 'Versturen…'; }

      try {
        const data = new FormData(form);
        const res  = await fetch('/contact#contact_form', { method: 'POST', body: data });
        if (res.ok) {
          if (msgEl) { msgEl.textContent = 'Bericht verzonden! We nemen snel contact op.'; msgEl.style.color = '#c4a35a'; }
          form.reset();
        } else {
          throw new Error();
        }
      } catch (_) {
        if (msgEl) { msgEl.textContent = 'Er ging iets mis. Probeer het opnieuw.'; msgEl.style.color = '#e05c5c'; }
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = 'Verstuur bericht →'; }
      }
    });
  }

  /* ── 6. Mobiel menu (hamburger + paneel) ── */
  function initMobielMenu() {
    const burger = document.querySelector('.sb-topbar__burger');
    const menu   = document.getElementById('sb-menu');
    const bar    = document.querySelector('.sb-topbar');
    if (!burger || !menu || !bar) return;

    // Het paneel hangt onder de sticky topbar; hoogte kan per breedte verschillen.
    function meetTopbar() {
      document.documentElement.style.setProperty('--sb-topbar-h', bar.getBoundingClientRect().height + 'px');
    }

    function zet(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
      menu.classList.toggle('sb-menu--open', open);
      if (open) meetTopbar();
    }

    meetTopbar();
    window.addEventListener('resize', () => {
      meetTopbar();
      if (window.innerWidth > 820) zet(false);
    }, { passive: true });

    burger.addEventListener('click', (e) => {
      e.stopPropagation();
      zet(burger.getAttribute('aria-expanded') !== 'true');
    });

    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => zet(false)));

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') zet(false); });
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && !burger.contains(e.target)) zet(false);
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initCounters();
    initCursor();
    initNav();
    initContactForm();
    initMobielMenu();
  });

})();
